module.exports = __webpack_public_path__ + "static/media/example-3.91d2fed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Koombana/example-3.jpg
// module id = 300
// module chunks = 0